export class BroadcastReceiver {
    resourceId: number;
    name:string;
    email:string;
}
